<template>
    <div class="list__symbol symbol">
        <div class="symbol__image-box" :style="{color: unitIconColor}">
            <SvgIcon style="height: 100%; width: 100%" :name="unitIcon" class="icon svg-icon-unit-marker" />
        </div>
        <template v-for="(indicator, i) in indicators" :key="i">
            <component :is="`UnitsList_unit_${indicator}_status`"
                       :unit-id="unitId"
                       v-if="indicator == 'text'"
            />
        </template>
    </div>
</template>

<script>
import UnitsList_unit_video_status from "@/components/units/UnitsList_unit_video_status.vue";
import UnitsList_unit_reefer_status from "@/components/units/UnitsList_unit_reefer_status.vue";
import UnitsList_unit_ignition_status from "@/components/units/UnitsList_unit_ignition_status.vue";
import UnitsList_unit_moving_status from "@/components/units/UnitsList_unit_moving_status.vue";
import UnitsList_unit_text_status from "@/components/units/UnitsList_unit_text_status.vue";
import UnitsList_unit_outputs_status from "@/components/units/UnitsList_unit_outputs_status.vue";

import unitMixin from "@/mixins/unitMixin";

export default {
    name: "UnitsList_unit_icons",
    mixins: [unitMixin],
    props: {
        unitId: Number,
        defaultIcon: {
            type: String,
            default: () => 'map__car_type_sedan'
        },
        indicators: {
            type: [Array, Object],
            default: () => {
                return ['ignition', 'moving', 'text'];
            }
        }
    },
    components: {
        UnitsList_unit_video_status,
        UnitsList_unit_reefer_status,
        UnitsList_unit_ignition_status,
        UnitsList_unit_moving_status,
        UnitsList_unit_text_status,
        UnitsList_unit_outputs_status,
    },
    computed:{
        unitIcon(){
            // let type = this.getUnitsTypes.find(t => {return t.id == this.unit?.type })
            // let icon = "common__"+(type ? type.icon : 'car')+"_lg"
            let icon = (this.unit?.icon || this.defaultIcon)
            return icon
        },
        unitIconColor(){
            return this.unit?.icon_color || '#003B79'
        },
    }
}
</script>

<style scoped>

</style>